<script>
  import { createEventDispatcher } from 'svelte';

  import { blurOnClick } from '../../../../../../js/blurOnClick';

  const dispatch = createEventDispatcher();

  export let isOpen = false;
  export let openText = 'Open menu';
  export let closeText = 'Close menu';

  function onClick() {
    dispatch('toggle');
  }
</script>

<button
  type="button"
  class="MenuToggle nav-button"
  class:isOpen
  aria-haspopup="true"
  aria-expanded={isOpen}
  on:click={onClick}
  use:blurOnClick
>
  <span class="text">
    {#if isOpen}{closeText}{:else}{openText}{/if}
  </span>
  <span class="icon" aria-hidden="true">
    <span class="iconBarTop"></span>
    <span class="iconBarBottom"></span>
    <span class="iconBarClockwise"></span>
    <span class="iconBarCounterwise"></span>
  </span>
</button>

<style>@charset "UTF-8";
.MenuToggle.nav-button {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  padding: 10px;
  transition: none;
}
.MenuToggle.nav-button:focus {
  outline: none;
}
.MenuToggle.nav-button::-moz-focus-inner {
  border: 0;
}
.MenuToggle.nav-button:focus {
  outline: none;
}
.MenuToggle.nav-button::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.MenuToggle.nav-button:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.MenuToggle.nav-button > * {
  position: relative;
}
.MenuToggle.nav-button .text {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}
.MenuToggle.nav-button .icon {
  display: block;
  position: relative;
  width: 22px;
  height: 22px;
}

.iconBarTop,
.iconBarBottom,
.iconBarClockwise,
.iconBarCounterwise {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  left: 50%;
  top: calc(50% - 1px);
  border-radius: 999em;
  background-color: var(--color-text, #1a1a1a);
}

.iconBarTop {
  transform: translate3d(-50%, -7px, 0);
}

.iconBarBottom {
  transform: translate3d(-50%, 7px, 0);
}

.iconBarTop,
.iconBarBottom {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 100ms, opacity 0ms 100ms;
}
.isOpen .iconBarTop,
.isOpen .iconBarBottom {
  opacity: 0;
  transform: translate3d(-50%, 0, 0);
  transition: transform 100ms cubic-bezier(0.4, 0, 1, 1), opacity 0ms 100ms;
}

.iconBarClockwise,
.iconBarCounterwise {
  transform: translate3d(-50%, 0, 0);
  transition: transform 100ms cubic-bezier(0.4, 0, 1, 1);
}
.isOpen .iconBarClockwise,
.isOpen .iconBarCounterwise {
  transition: transform 100ms cubic-bezier(0, 0, 0.2, 1) 100ms;
}

.isOpen .iconBarClockwise {
  transform: translate3d(-50%, 0, 0) rotate(45deg);
}
.isOpen .iconBarCounterwise {
  transform: translate3d(-50%, 0, 0) rotate(-45deg);
}</style>
